// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@100;400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom Grid */
/******************/
.rcv-container {
  font-family: Helvetica;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  display: flex;
  /* border: 1px solid black; */
  width: 100%;
  /* overflow: auto;
  height: inherit; */
  flex-wrap: wrap;
}


.rcv-object {
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-grow: 0 !important;
  flex-shrink: 0;
  margin: 5px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(25% - 10px);
  box-sizing: border-box;
}

.rcv-object:nth-of-type(n+5) {
  flex-basis: calc(25% - 10px);
}

.rcv-card-sm {
  width: 230px;
}
.rcv-card-md {
  width: 380px;
}
.rcv-card-lg {
  width: 516px;
}

.rcv-object-sm {
  width: 270px;
  margin: 15px 0;
}
.rcv-object-md {
  width: 415px;
  margin: 15px 0;
}
.rcv-object-lg {
  width: 588px;
  margin: 15px 0;
}

.rcv-product-price {
  display: flex;
  margin: 6px 5px;
  justify-content: center;
}
.rcv-original,
.rcv-original-price-custom {
  margin: 2px;
  font-weight: bold;
}
.rcv-discount,
.rcv-discount-price-custom {
  margin: 2px;
  font-weight: bold;
}
.rcv-strike {
  font-weight: unset;
  text-decoration: line-through;
  font-size: 0.89em;
}

.rcv-product-buttons {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.rcv-btn-one, .rcv-btn-two {
  background-color: #9b4dca;
  border: 0.1rem solid #9b4dca;
  border-radius: 0.4rem;
  color: #fff;
  cursor: pointer;
  font-weight: 700;
  height: 2.6em;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  margin: 2px 0;
}

.rcv-btn-one:hover, .rcv-btn-two:hover {
  background-color: #606c76;
  border-color: #606c76;
  color: #fff;
  outline: 0;
}

@media (max-width: 575px) {
  .rcv-object-sm,
  .rcv-object-md,
  .rcv-object-lg {
    width: 100%;
  }
  .rcv-card-sm,
  .rcv-card-md,
  .rcv-card-lg {
    width: 90%;
  }
  .rcv-btn-one, .rcv-btn-two {
    min-height: 2em;
    margin: 2px;
    height: unset;
    font-size: 0.6em;
    padding: 5px 13px;
  }
  .rcv-product-buttons {
    /*flex-direction: unset;*/
  }
}

/******************/
/* Card Style */
.rcv-catalog-card {
  padding: 12px;
}

.rcv-card-text {
  flex-direction: column;
}

/* Small Card */

.rcv-card-sm .rcv-product-image-container,
.rcv-card-sm .rcv-product-image-container-custom{
  width: 220px;
  margin: 0 5px;
}
.rcv-card-sm .rcv-product-image-container > img,
.rcv-card-sm .rcv-product-image-container-custom > img{
  object-fit: contain;
  width: 100%;
  height: 150px;
}
.rcv-card-sm .rcv-product-text,
.rcv-card-sm .rcv-product-text-custom {
  margin: 0 5px;
  color: #4d4d4d;
}

.rcv-product-description{
  font-size: 0.85em;
  color: white;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 0 auto;
  height: 44px;
  text-align: center;
}
.rcv-card-sm .rcv-product-description {
  max-width: 230px;
}

.rcv-card-md .rcv-product-description {
  max-width: 380px;
}

.rcv-card-lg .rcv-product-description{
  max-width: 516px;
}

/* Medium Card */

.rcv-card-md .rcv-product-image-container,
.rcv-card-md .rcv-product-image-container-custom {
  width: 360px;
  margin: 0 10px;
}
.rcv-card-md .rcv-product-image-container > img,
.rcv-card-md .rcv-product-image-container-custom > img {
  object-fit: contain;
  width: 100%;
  height: 220px;
}

.rcv-card-md .rcv-product-text,
.rcv-card-md .rcv-product-text-custom {
  margin: 0 10px;
}

.rcv-card-md .rcv-product-price {
  display: flex;
  margin: 6px 10px;
}

/* Large Card */

.rcv-card-lg .rcv-product-image-container,
.rcv-card-lg .rcv-product-image-container-custom {
  width: 500px;
  margin: 0 8px;
}
.rcv-card-lg .rcv-product-image-container > img,
.rcv-card-lg .rcv-product-image-container-custom > img {
  object-fit: contain;
  width: 100%;
  height: 340px;
}

.rcv-card-lg .rcv-product-text,
.rcv-card-lg .rcv-product-text-custom{
  margin: 0 8px;
}

@media (max-width: 575px) {
  .rcv-card-content {
    /*display: flex;*/
  }
  .rcv-card-sm .rcv-product-image-container > img,
  .rcv-card-md .rcv-product-image-container > img,
  .rcv-card-lg .rcv-product-image-container > img,
  .rcv-card-sm .rcv-product-image-container-custom > img,
  .rcv-card-md .rcv-product-image-container-custom > img,
  .rcv-card-lg .rcv-product-image-container-custom > img {
    width: 100%;
    margin-left: 0;
  }
  .rcv-card-sm .rcv-product-image-container,
  .rcv-card-md .rcv-product-image-container,
  .rcv-card-lg .rcv-product-image-container,
  .rcv-card-sm .rcv-product-image-container-custom,
  .rcv-card-md .rcv-product-image-container-custom,
  .rcv-card-lg .rcv-product-image-container-custom {
    width: 50%;
    margin: 0 auto;
  }
  .rcv-card-sm .rcv-product-description,
  .rcv-card-md .rcv-product-description,
  .rcv-card-lg .rcv-product-description,
  .rcv-card-sm .rcv-product-description-custom,
  .rcv-card-md .rcv-product-description-custom,
  .rcv-card-lg .rcv-product-description-custom {
    max-width: 200px;
  }
  .rcv-product-buttons {
    /*justify-content: left;*/
  }
  .rcv-product-buttons button {
    color: white;
  }
  .rcv-card-md .rcv-product-description,
  .rcv-card-md .rcv-product-description-custom {
    height: 98px;
    font-size: 0.85em;
    opacity: 0.6;
    text-overflow: unset;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
  }
  .rcv-card-lg .rcv-product-description,
  .rcv-card-lg .rcv-product-description-custom {
    height: 210px;
    font-size: 0.85em;
    opacity: 0.6;
    text-overflow: unset;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
  }
  .rcv-product-text h4, .rcv-product-text-custom h4 {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
    margin: 7px auto;
  }
}

/* Skeleton CSS */

.skeleton {  
  background: rgba(0, 0, 0, 0.3);
  color: transparent;
  opacity: 0.3;
  position: relative;
  overflow: hidden;
  user-select: none; /* Standard */
  -webkit-user-select: none; /* Safari */        
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */  
}
.skeleton-animate {
  content: "";
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
    to right,
    transparent 0%,
    #e8e8e8 50%,
    transparent 100%
  );
  animation: load 1s infinite cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 130%;
  }
}

.rcv-product-description.skeleton {
  opacity: 0.2;
  color: transparent;
}
button.skeleton,
button.skeleton:hover {  
  color: transparent;
  border-color: transparent;
  cursor: default;
}

.rcv-card-md .rcv-product-image-container .sk-img,
.rcv-card-md .rcv-product-image-container-custom .sk-img {	
    height: 220px;
}
.rcv-card-sm .rcv-product-image-container .sk-img,
.rcv-card-sm .rcv-product-image-container-custom .sk-img {
  height: 150px;
}

.rcv-card-lg .rcv-product-image-container .sk-img,
.rcv-card-lg .rcv-product-image-container-custom .sk-img {
  height: 340px;
}


/*
.rcv-container-custom
.rcv-object-sm-custom  @media(max-width: 575px)
.rcv-object-md-custom  @media(max-width: 575px)
.rcv-object-lg-custom  @media(max-width: 575px)
.rcv-catalog-card-custom
.rcv-product-image-container-custom
.rcv-product-image-container-custom>img
.rcv-product-text-custom
.rcv-product-name-custom
.rcv-product-description-custom
.rcv-original-price-custom
.rcv-discount-price-custom
.rcv-btn-one-custom
.rcv-btn-two-custom
*/

/* .rcv-btn-one-custom{
  background-color:#5d5e8a;
  border:none
}
.rcv-catalog-card-custom{border-radius:12px; background: #27273a; box-shadow: none;}
.rcv-product-image-container-custom>img {border-radius:12px;}
.rcv-product-text-custom,
.rcv-product-name-custom,
.rcv-product-description-custom,
.rcv-original-price-custom,
.rcv-discount-price-custom{
  color:#FFFFFF;
}
.rcv-container-custom{background-color: rgb(62, 59, 66);} */

/* .blue{ background:DarkOrchid; padding:15px;opacity:0.5; border:none; padding:5px; font-size: 1.5em;margin:2px; color:black;}
.red{ background:DarkOrchid; color:white;padding:15px;border:none; padding:5px; margin:2px; font-size: 1.5em;}
.blue:focus, .red:focus, .red:active, .blue:active{border:none; outline:none; }
label {font-size:20px;} */


.test-view-withnav li{
  padding: 12px 23px;
  border-bottom: 1px solid rgb(191, 191, 191);
  text-transform: uppercase;
}
.test-view-withnav #sidenav{
  background:#f7f5f7
}

.test-view-withnav ul {
  list-style-type: none;
  margin-left: -40px;
 }

 body{
   margin:0;
   padding: 0;
   font-family: 'Lato', Courier, monospace !important;
 }`, "",{"version":3,"sources":["webpack://./src/Catalog.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,mBAAmB;AAEnB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX;oBACkB;EAClB,eAAe;AACjB;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;AACA;;EAEE,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;;;IAGE,WAAW;EACb;EACA;;;IAGE,UAAU;EACZ;EACA;IACE,eAAe;IACf,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,mBAAmB;AACnB,eAAe;AACf;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA,eAAe;;AAEf;;EAEE,YAAY;EACZ,aAAa;AACf;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AACA;;EAEE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;;AAEhB;;EAEE,YAAY;EACZ,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;;EAEE,YAAY;EACZ,aAAa;AACf;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;;;;;;IAME,WAAW;IACX,cAAc;EAChB;EACA;;;;;;IAME,UAAU;IACV,cAAc;EAChB;EACA;;;;;;IAME,gBAAgB;EAClB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,YAAY;EACd;EACA;;IAEE,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;EACvB;EACA;;IAEE,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,iBAAiB;;AAEjB;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,yBAAyB,EAAE,WAAW;EACtC,sBAAsB,EAAE,YAAY;EACpC,qBAAqB,EAAE,eAAe;AACxC;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,YAAY;EACZ,YAAY;EACZ;;;;;GAKC;EACD,wDAAwD;AAC1D;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;IAEI,aAAa;AACjB;AACA;;EAEE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;;AAGA;;;;;;;;;;;;;;;CAeC;;AAED;;;;;;;;;;;;;2DAa2D;;AAE3D;;;yBAGyB;;;AAGzB;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;CACnB;;CAEA;GACE,QAAQ;GACR,UAAU;GACV,kDAAkD;CACpD","sourcesContent":["/* Custom Grid */\n/******************/\n@import url('https://fonts.googleapis.com/css2?family=Lato:wght@100;400&display=swap');\n.rcv-container {\n  font-family: Helvetica;\n  flex-flow: row wrap;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  display: flex;\n  /* border: 1px solid black; */\n  width: 100%;\n  /* overflow: auto;\n  height: inherit; */\n  flex-wrap: wrap;\n}\n\n\n.rcv-object {\n  width: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: stretch;\n  flex-grow: 0 !important;\n  flex-shrink: 0;\n  margin: 5px;\n  flex: 1 1 calc(25% - 10px);\n  box-sizing: border-box;\n}\n\n.rcv-object:nth-of-type(n+5) {\n  flex-basis: calc(25% - 10px);\n}\n\n.rcv-card-sm {\n  width: 230px;\n}\n.rcv-card-md {\n  width: 380px;\n}\n.rcv-card-lg {\n  width: 516px;\n}\n\n.rcv-object-sm {\n  width: 270px;\n  margin: 15px 0;\n}\n.rcv-object-md {\n  width: 415px;\n  margin: 15px 0;\n}\n.rcv-object-lg {\n  width: 588px;\n  margin: 15px 0;\n}\n\n.rcv-product-price {\n  display: flex;\n  margin: 6px 5px;\n  justify-content: center;\n}\n.rcv-original,\n.rcv-original-price-custom {\n  margin: 2px;\n  font-weight: bold;\n}\n.rcv-discount,\n.rcv-discount-price-custom {\n  margin: 2px;\n  font-weight: bold;\n}\n.rcv-strike {\n  font-weight: unset;\n  text-decoration: line-through;\n  font-size: 0.89em;\n}\n\n.rcv-product-buttons {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.rcv-btn-one, .rcv-btn-two {\n  background-color: #9b4dca;\n  border: 0.1rem solid #9b4dca;\n  border-radius: 0.4rem;\n  color: #fff;\n  cursor: pointer;\n  font-weight: 700;\n  height: 2.6em;\n  letter-spacing: 0.1rem;\n  text-transform: uppercase;\n  margin: 2px 0;\n}\n\n.rcv-btn-one:hover, .rcv-btn-two:hover {\n  background-color: #606c76;\n  border-color: #606c76;\n  color: #fff;\n  outline: 0;\n}\n\n@media (max-width: 575px) {\n  .rcv-object-sm,\n  .rcv-object-md,\n  .rcv-object-lg {\n    width: 100%;\n  }\n  .rcv-card-sm,\n  .rcv-card-md,\n  .rcv-card-lg {\n    width: 90%;\n  }\n  .rcv-btn-one, .rcv-btn-two {\n    min-height: 2em;\n    margin: 2px;\n    height: unset;\n    font-size: 0.6em;\n    padding: 5px 13px;\n  }\n  .rcv-product-buttons {\n    /*flex-direction: unset;*/\n  }\n}\n\n/******************/\n/* Card Style */\n.rcv-catalog-card {\n  padding: 12px;\n}\n\n.rcv-card-text {\n  flex-direction: column;\n}\n\n/* Small Card */\n\n.rcv-card-sm .rcv-product-image-container,\n.rcv-card-sm .rcv-product-image-container-custom{\n  width: 220px;\n  margin: 0 5px;\n}\n.rcv-card-sm .rcv-product-image-container > img,\n.rcv-card-sm .rcv-product-image-container-custom > img{\n  object-fit: contain;\n  width: 100%;\n  height: 150px;\n}\n.rcv-card-sm .rcv-product-text,\n.rcv-card-sm .rcv-product-text-custom {\n  margin: 0 5px;\n  color: #4d4d4d;\n}\n\n.rcv-product-description{\n  font-size: 0.85em;\n  color: white;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin: 0 auto;\n  height: 44px;\n  text-align: center;\n}\n.rcv-card-sm .rcv-product-description {\n  max-width: 230px;\n}\n\n.rcv-card-md .rcv-product-description {\n  max-width: 380px;\n}\n\n.rcv-card-lg .rcv-product-description{\n  max-width: 516px;\n}\n\n/* Medium Card */\n\n.rcv-card-md .rcv-product-image-container,\n.rcv-card-md .rcv-product-image-container-custom {\n  width: 360px;\n  margin: 0 10px;\n}\n.rcv-card-md .rcv-product-image-container > img,\n.rcv-card-md .rcv-product-image-container-custom > img {\n  object-fit: contain;\n  width: 100%;\n  height: 220px;\n}\n\n.rcv-card-md .rcv-product-text,\n.rcv-card-md .rcv-product-text-custom {\n  margin: 0 10px;\n}\n\n.rcv-card-md .rcv-product-price {\n  display: flex;\n  margin: 6px 10px;\n}\n\n/* Large Card */\n\n.rcv-card-lg .rcv-product-image-container,\n.rcv-card-lg .rcv-product-image-container-custom {\n  width: 500px;\n  margin: 0 8px;\n}\n.rcv-card-lg .rcv-product-image-container > img,\n.rcv-card-lg .rcv-product-image-container-custom > img {\n  object-fit: contain;\n  width: 100%;\n  height: 340px;\n}\n\n.rcv-card-lg .rcv-product-text,\n.rcv-card-lg .rcv-product-text-custom{\n  margin: 0 8px;\n}\n\n@media (max-width: 575px) {\n  .rcv-card-content {\n    /*display: flex;*/\n  }\n  .rcv-card-sm .rcv-product-image-container > img,\n  .rcv-card-md .rcv-product-image-container > img,\n  .rcv-card-lg .rcv-product-image-container > img,\n  .rcv-card-sm .rcv-product-image-container-custom > img,\n  .rcv-card-md .rcv-product-image-container-custom > img,\n  .rcv-card-lg .rcv-product-image-container-custom > img {\n    width: 100%;\n    margin-left: 0;\n  }\n  .rcv-card-sm .rcv-product-image-container,\n  .rcv-card-md .rcv-product-image-container,\n  .rcv-card-lg .rcv-product-image-container,\n  .rcv-card-sm .rcv-product-image-container-custom,\n  .rcv-card-md .rcv-product-image-container-custom,\n  .rcv-card-lg .rcv-product-image-container-custom {\n    width: 50%;\n    margin: 0 auto;\n  }\n  .rcv-card-sm .rcv-product-description,\n  .rcv-card-md .rcv-product-description,\n  .rcv-card-lg .rcv-product-description,\n  .rcv-card-sm .rcv-product-description-custom,\n  .rcv-card-md .rcv-product-description-custom,\n  .rcv-card-lg .rcv-product-description-custom {\n    max-width: 200px;\n  }\n  .rcv-product-buttons {\n    /*justify-content: left;*/\n  }\n  .rcv-product-buttons button {\n    color: white;\n  }\n  .rcv-card-md .rcv-product-description,\n  .rcv-card-md .rcv-product-description-custom {\n    height: 98px;\n    font-size: 0.85em;\n    opacity: 0.6;\n    text-overflow: unset;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: pre-wrap;\n  }\n  .rcv-card-lg .rcv-product-description,\n  .rcv-card-lg .rcv-product-description-custom {\n    height: 210px;\n    font-size: 0.85em;\n    opacity: 0.6;\n    text-overflow: unset;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: pre-wrap;\n  }\n  .rcv-product-text h4, .rcv-product-text-custom h4 {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    max-width: 200px;\n    margin: 7px auto;\n  }\n}\n\n/* Skeleton CSS */\n\n.skeleton {  \n  background: rgba(0, 0, 0, 0.3);\n  color: transparent;\n  opacity: 0.3;\n  position: relative;\n  overflow: hidden;\n  user-select: none; /* Standard */\n  -webkit-user-select: none; /* Safari */        \n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE10+/Edge */  \n}\n.skeleton-animate {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: -150px;\n  top: 0;\n  height: 100%;\n  width: 150px;\n  background: linear-gradient(\n    to right,\n    transparent 0%,\n    #e8e8e8 50%,\n    transparent 100%\n  );\n  animation: load 1s infinite cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@keyframes load {\n  from {\n    left: -150px;\n  }\n  to {\n    left: 130%;\n  }\n}\n\n.rcv-product-description.skeleton {\n  opacity: 0.2;\n  color: transparent;\n}\nbutton.skeleton,\nbutton.skeleton:hover {  \n  color: transparent;\n  border-color: transparent;\n  cursor: default;\n}\n\n.rcv-card-md .rcv-product-image-container .sk-img,\n.rcv-card-md .rcv-product-image-container-custom .sk-img {\t\n    height: 220px;\n}\n.rcv-card-sm .rcv-product-image-container .sk-img,\n.rcv-card-sm .rcv-product-image-container-custom .sk-img {\n  height: 150px;\n}\n\n.rcv-card-lg .rcv-product-image-container .sk-img,\n.rcv-card-lg .rcv-product-image-container-custom .sk-img {\n  height: 340px;\n}\n\n\n/*\n.rcv-container-custom\n.rcv-object-sm-custom  @media(max-width: 575px)\n.rcv-object-md-custom  @media(max-width: 575px)\n.rcv-object-lg-custom  @media(max-width: 575px)\n.rcv-catalog-card-custom\n.rcv-product-image-container-custom\n.rcv-product-image-container-custom>img\n.rcv-product-text-custom\n.rcv-product-name-custom\n.rcv-product-description-custom\n.rcv-original-price-custom\n.rcv-discount-price-custom\n.rcv-btn-one-custom\n.rcv-btn-two-custom\n*/\n\n/* .rcv-btn-one-custom{\n  background-color:#5d5e8a;\n  border:none\n}\n.rcv-catalog-card-custom{border-radius:12px; background: #27273a; box-shadow: none;}\n.rcv-product-image-container-custom>img {border-radius:12px;}\n.rcv-product-text-custom,\n.rcv-product-name-custom,\n.rcv-product-description-custom,\n.rcv-original-price-custom,\n.rcv-discount-price-custom{\n  color:#FFFFFF;\n}\n.rcv-container-custom{background-color: rgb(62, 59, 66);} */\n\n/* .blue{ background:DarkOrchid; padding:15px;opacity:0.5; border:none; padding:5px; font-size: 1.5em;margin:2px; color:black;}\n.red{ background:DarkOrchid; color:white;padding:15px;border:none; padding:5px; margin:2px; font-size: 1.5em;}\n.blue:focus, .red:focus, .red:active, .blue:active{border:none; outline:none; }\nlabel {font-size:20px;} */\n\n\n.test-view-withnav li{\n  padding: 12px 23px;\n  border-bottom: 1px solid rgb(191, 191, 191);\n  text-transform: uppercase;\n}\n.test-view-withnav #sidenav{\n  background:#f7f5f7\n}\n\n.test-view-withnav ul {\n  list-style-type: none;\n  margin-left: -40px;\n }\n\n body{\n   margin:0;\n   padding: 0;\n   font-family: 'Lato', Courier, monospace !important;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
